import { gsap, ScrollTrigger } from "./globals.js";
import { animateChars } from './animate-chars.js';

document.addEventListener("DOMContentLoaded", () => {
	const pinnedSliderSection = document.querySelector(".pinned-slider");
	if (!pinnedSliderSection) return;

	// Check if a .swiper-wrapper appears above .pinned-slider in DOM
	const swiperWrappers = document.querySelectorAll(".swiper-wrapper");
	let delayInit = false;

	swiperWrappers.forEach(swiper => {
		if (swiper.compareDocumentPosition(pinnedSliderSection) & Node.DOCUMENT_POSITION_FOLLOWING) {
			delayInit = true;
		}
	});

	const runPinnedSliderAnimation = () => {
		const imageSlides = document.querySelectorAll(".pinned-slider__slides__images .image");
		const titleSlides = document.querySelectorAll(".pinned-slider__slides__titles .title");

		const slideCount = imageSlides.length;
		let scrollPerSlide;

		if (window.innerWidth < 1025) {
			scrollPerSlide = 625;
		} else {
			scrollPerSlide = 1000;
		}

		const scrollDistance = slideCount * scrollPerSlide;

		const latestWorkTl = gsap.timeline({
			scrollTrigger: {
				trigger: pinnedSliderSection,
				start: "top top",
				end: `+=${scrollDistance}`,
				scrub: 1,
				pin: true,
			}
		});


		imageSlides.forEach((img, i) => {
			const slideLabel = `slide-${i}`;
			latestWorkTl.addLabel(slideLabel);

			if (i === 0) {
				latestWorkTl.add(animateChars(`.pinned-slider__slides__titles .title:nth-child(1)`), slideLabel);
				const firstBtn = titleSlides[0]?.querySelector(".ui-btn");
				if (firstBtn) {
					latestWorkTl.to(firstBtn, {
						opacity: 1,
						visibility: "visible",
						ease: "power2.out"
					}, slideLabel + "+=1.2");
				}
			}

			gsap.set(img.querySelector("img"), { y: i === 0 ? "0%" : "10%" });

			if (i < imageSlides.length - 1 && imageSlides[i + 1]) {
				const nextImage = imageSlides[i + 1];
				const nextImgEl = nextImage.querySelector("img");
				const currentTitle = titleSlides[i];
				const nextTitle = titleSlides[i + 1];
				const transitionLabel = `transition-${i}`;
				const insetAmount = 20 + i * 20;

				latestWorkTl.addLabel(transitionLabel, i === 0 ? ">1.5" : ">.8");

				latestWorkTl.to(currentTitle, {
					opacity: 0,
					duration: 2.2,
					ease: "power1.out"
				}, transitionLabel);

				const currentBtn = currentTitle?.querySelector(".ui-btn");
				if (currentBtn) {
					latestWorkTl.to(currentBtn, {
						opacity: 0,
						visibility: "hidden",
						duration: 0.4,
						ease: "power2.out"
					}, transitionLabel + "+=0.1");
				}

				latestWorkTl.fromTo(nextImage, {
					clipPath: "inset(100% 0 0 0 round 22px)"
				}, {
					clipPath: `inset(${insetAmount}px 0 0 0 round 22px)`,
					duration: 5,
					ease: "power1.inOut"
				}, transitionLabel);

				if (nextImgEl) {
					latestWorkTl.to(nextImgEl, {
						y: "0%",
						duration: 5,
						ease: "power1.inOut"
					}, transitionLabel);
				}

				latestWorkTl.to(img.querySelector("img"), {
					y: "-10%",
					duration: 5,
					ease: "power1.inOut"
				}, transitionLabel);

				for (let j = 0; j <= i; j++) {
					const scaleFactor = 1 - (0.03 * (i - j + 1));
					latestWorkTl.to(imageSlides[j], {
						scaleX: scaleFactor,
						duration: 5,
						ease: "power1.inOut"
					}, transitionLabel);
				}

				latestWorkTl.add(
					animateChars(`.pinned-slider__slides__titles .title:nth-child(${i + 2})`),
					transitionLabel + "+=" + (2 * (slideCount / 4))
				);

				const nextBtn = nextTitle?.querySelector(".ui-btn");
				if (nextBtn) {
					latestWorkTl.to(
						nextBtn,
						{
							opacity: 1,
							visibility: "visible",
							duration: 2,
							ease: "power2.out"
						},
						transitionLabel + "+=" + (3.2 * (slideCount / 4))
					);
				}
			}
		});
	};

	// Delay only if needed
	if (delayInit) {
		setTimeout(runPinnedSliderAnimation, 300);
	} else {
		runPinnedSliderAnimation();
	}
});
